export const DemographicRegions = {
  Native: 'Native',
  US: 'US',
  CA: 'CA',
} as const;

export type DemographicRegion = typeof DemographicRegions[keyof typeof DemographicRegions];

export const DEMOGRAPHIC_REGIONS_FOR_PREMIUM_DATA: ReadonlyArray<DemographicRegion> = [
  DemographicRegions.US,
  DemographicRegions.CA,
];
